import React from 'react'
import ZionForm, { FormTextField } from '@fs/zion-form'
import { Row, Cell, Button, LabelSpacer } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { type UseFormReturn } from 'react-hook-form'

type SearchFormValues = {
  solrSearch: string
}

type SearchFormProps = Readonly<{
  methods: UseFormReturn<SearchFormValues>
  onSubmit: (values: SearchFormValues) => void
  isValid: boolean
}>

const SearchForm = ({ methods, onSubmit, isValid }: SearchFormProps) => {
  const [t] = useTranslation()

  return (
    <ZionForm methods={methods as any} onSubmit={onSubmit}>
      <Row alignX="start">
        <FormTextField
          growX
          label={t('place-learn-to-rank-page.search-form.solr-search.label', 'Solr Search')}
          name="solrSearch"
          placeholder={t('place-learn-to-rank-page.search-form.yuma-az.placeholder', 'Yuma AZ')}
        />
        <Cell growX>
          <LabelSpacer />
          <Button emphasis="high" type="submit" disabled={!isValid}>
            {t('place-learn-to-rank-page.search-form.search.button', 'Search')}
          </Button>
        </Cell>
      </Row>
    </ZionForm>
  )
}

export default SearchForm
